var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "task-trace-viewer" },
    [
      _vm.task && _vm.task.loading
        ? _c("div", { staticClass: "loading-container" }, [
            _c("div", { staticClass: "loading-content" }, [
              _c("i", { staticClass: "material-icons rotating" }, [
                _vm._v("refresh"),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  _vm._s(_vm.$t("auto.taskTraceViewerTaskDetaylarYKleniyor"))
                ),
              ]),
            ]),
          ])
        : _c("div", { staticClass: "trace-header" }, [
            _c("div", { staticClass: "task-info" }, [
              _c("div", { staticClass: "header-top" }, [
                _c("h4", [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("timeline"),
                  ]),
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("auto.taskTraceViewerTaskTraceReview")) +
                      "\n                "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "view-toggle" },
                  [
                    _c(
                      "a-button-group",
                      [
                        _c(
                          "a-button",
                          {
                            attrs: {
                              type:
                                _vm.viewMode === "list" ? "primary" : "default",
                              size: "small",
                            },
                            on: {
                              click: function ($event) {
                                _vm.viewMode = "list"
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("list"),
                            ]),
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("auto.taskTraceViewerListe")) +
                                "\n                        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a-button",
                          {
                            attrs: {
                              type:
                                _vm.viewMode === "diagram"
                                  ? "primary"
                                  : "default",
                              size: "small",
                            },
                            on: {
                              click: function ($event) {
                                _vm.viewMode = "diagram"
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("account_tree"),
                            ]),
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("auto.taskTraceViewerHarita")) +
                                "\n                        "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "task-meta" }, [
                _c("span", { staticClass: "meta-item" }, [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.$t("auto.taskTraceViewerTaskId"))),
                  ]),
                  _vm._v(" " + _vm._s(_vm.task._id) + "\n                "),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "meta-item" }, [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.$t("auto.taskTraceViewerPlanId"))),
                  ]),
                  _vm._v(" " + _vm._s(_vm.plan._id) + "\n                "),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "meta-item" }, [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.$t("auto.taskTraceViewerStatus"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "status-badge",
                      attrs: { "data-status": _vm.task.status },
                    },
                    [_vm._v(_vm._s(_vm.task.status))]
                  ),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "meta-item" }, [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.$t("auto.taskTraceViewerDuration"))),
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.formatDuration(
                          _vm.$_.get(_vm.task, "state.duration", 0)
                        )
                      ) +
                      "\n                "
                  ),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "meta-item" }, [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.$t("auto.taskTraceViewerWakeUpCount"))),
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$_.get(_vm.task, "state.wakeUpCount", 0)) +
                      "\n                "
                  ),
                ]),
              ]),
            ]),
          ]),
      _vm._v(" "),
      _vm.viewMode === "list"
        ? _c("div", { staticClass: "trace-timeline" }, [
            _c("div", { staticClass: "timeline-header" }, [
              _c("h5", [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("account_tree"),
                ]),
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.$t("auto.taskTraceViewerBlockExecutionHistory")
                    ) +
                    "\n            "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "timeline-container" },
              _vm._l(_vm.executionHistory, function (blockId, index) {
                return _c(
                  "div",
                  {
                    key: blockId + "-" + index,
                    staticClass: "timeline-item",
                    class: {
                      "current-position": blockId === _vm.currentPosition,
                    },
                  },
                  [
                    _c("div", { staticClass: "timeline-marker" }, [
                      _c("span", { staticClass: "step-number" }, [
                        _vm._v(_vm._s(index + 1)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "timeline-content" }, [
                      _c(
                        "div",
                        { staticClass: "block-header" },
                        [
                          _c("div", { staticClass: "block-info" }, [
                            _c("h6", [
                              _vm._v(_vm._s(_vm.getBlockName(blockId))),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "block-id" }, [
                              _vm._v(_vm._s(_vm.$t("auto.taskTraceViewerID"))),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "a-button",
                            {
                              staticClass: "diagram-btn",
                              attrs: {
                                size: "small",
                                type: "default",
                                title: _vm.$t(
                                  "auto.taskTraceViewerDiagramdaKonumunuGSter"
                                ),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.openDiagramModal(blockId)
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("map"),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.getBlockValue(blockId)
                        ? _c("div", { staticClass: "block-value" }, [
                            _c(
                              "div",
                              { staticClass: "value-header" },
                              [
                                _c("span", { staticClass: "value-label" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("auto.taskTraceViewerBlockValue")
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "a-button",
                                  {
                                    staticClass: "view-value-btn",
                                    attrs: { size: "small", type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openBlockValueModal(blockId)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "material-icons" }, [
                                      _vm._v("code"),
                                    ]),
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.$t(
                                            "auto.taskTraceViewerDeEriGRNtLe"
                                          )
                                        ) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ])
                        : _c("div", { staticClass: "no-value" }, [
                            _c("span", { staticClass: "no-value-text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "auto.taskTraceViewerBuBlockIInDeErKaydedilmemi"
                                  )
                                )
                              ),
                            ]),
                          ]),
                    ]),
                  ]
                )
              }),
              0
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.viewMode === "diagram"
        ? _c(
            "div",
            {
              staticClass: "trace-diagram",
              class: { fullscreen: _vm.diagramFullscreen },
            },
            [
              _c("LiteDiagramViewer", {
                attrs: {
                  diagram: _vm.diagramSnapshot,
                  "highlighted-blocks": _vm.highlightedBlocks,
                  "execution-history": _vm.executionHistory,
                  "current-position": _vm.currentPosition,
                  "block-values": _vm.blockValues,
                  "show-payload-button": true,
                  "fullscreen-mode": _vm.diagramFullscreen,
                },
                on: {
                  blockClicked: _vm.handleDiagramBlockClick,
                  showPayload: _vm.openPayloadModalFromDiagram,
                  toggleFullscreen: _vm.toggleDiagramFullscreen,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.customAttributes && Object.keys(_vm.customAttributes).length > 0
        ? _c("div", { staticClass: "custom-attributes" }, [
            _c(
              "div",
              { staticClass: "attributes-header" },
              [
                _c("h5", [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("settings"),
                  ]),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("auto.taskTraceViewerCustomAttributes")) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    staticClass: "toggle-btn",
                    attrs: { size: "small", type: "link" },
                    on: { click: _vm.toggleCustomAttributes },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.showCustomAttributes ? "Gizle" : "Göster") +
                        "\n                "
                    ),
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.showCustomAttributes
                              ? "expand_less"
                              : "expand_more"
                          ) +
                          "\n                "
                      ),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.showCustomAttributes
              ? _c("div", { staticClass: "attributes-content" }, [
                  _c(
                    "div",
                    { staticClass: "json-viewer-container" },
                    [
                      _c("v-jsoneditor", {
                        attrs: {
                          value: _vm.customAttributes,
                          options: _vm.jsonEditorOptions,
                          height: "300px",
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.task.terminateReason
        ? _c("div", { staticClass: "terminate-reason" }, [
            _c("div", { staticClass: "reason-header" }, [
              _c("h5", [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("report_problem"),
                ]),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("auto.taskTraceViewerTerminateReason")) +
                    "\n            "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "reason-content" }, [
              _c("span", { staticClass: "reason-text" }, [
                _vm._v(_vm._s(_vm.task.terminateReason)),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showBlockValueModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.blockValueModalTitle,
                showFooter: false,
                xlarge: "",
              },
              on: { cancel: _vm.closeBlockValueModal },
            },
            [
              _c(
                "div",
                { staticClass: "block-value-modal-content" },
                [
                  _c("v-jsoneditor", {
                    attrs: {
                      options: _vm.modalJsonEditorOptions,
                      height: "500px",
                    },
                    model: {
                      value: _vm.selectedBlockValue,
                      callback: function ($$v) {
                        _vm.selectedBlockValue = $$v
                      },
                      expression: "selectedBlockValue",
                    },
                  }),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showDiagramModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("auto.taskTraceViewerBlockKonumGRNM"),
                showFooter: false,
                large: "",
              },
              on: { cancel: _vm.closeDiagramModal },
            },
            [
              _c(
                "div",
                { staticClass: "diagram-modal-content" },
                [
                  _c("LiteDiagramViewer", {
                    attrs: {
                      diagram: _vm.diagramSnapshot,
                      "highlighted-blocks": [_vm.selectedBlockForDiagram],
                      "execution-history": _vm.executionHistory,
                      "current-position": _vm.currentPosition,
                      "block-values": _vm.blockValues,
                      "show-payload-button": true,
                      "fullscreen-mode": false,
                    },
                    on: {
                      blockClicked: _vm.handleDiagramBlockClick,
                      showPayload: _vm.openPayloadModalFromDiagram,
                    },
                  }),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }